<template>
	
    <div class="vpay__content-area" v-loading="loading">
		
		<h2 class="vpay__title-bar"><ion-icon class="vpay__title-bar-close" name="arrow-back" @click="onClickClose"></ion-icon>Terms & Conditions</h2>
		
		<div v-html="$store.getters.account.settings.terms_and_conditions" class="vpay__content-area-inner" @change="linkTargetBlank"></div>
		
    </div>
	
</template>

<script>
	
    export default {
		
        name: "TermsAndConditions",
		
		methods: {
			
			onClickClose() {
				this.$store.commit("displayComponentName", null);
			},
			linkTargetBlank() {
				let container = document.getElementsByClassName('vpay__content-area-inner')[0]
				let links = container.getElementsByTagName('a')
				for (let i = 0, len = links.length; i < len; i++) { 
					links[i].target = '_blank'
				}
			}
			
		},
		
		data() {
			return {
				loading: false,
			};
		},
		mounted() {
			this.linkTargetBlank()
		}
		
    }
	
</script>

<style>
	
	
	
</style>
